export const EVENT_TYPES = {
  CLICKSTREAM_VIEW: 'clickstream_view',
  CLICKSTREAM_COMPONENT_VIEW: 'clickstream_component_view',
  CLICKSTREAM_INTERACTION: 'clickstream_interaction',
  CLICKSTREAM_SIGN_IN_START: 'clickstream_sign_in_start',
  CLICKSTREAM_SIGN_IN_SUCCESS: 'clickstream_sign_in_success',
  CLICKSTREAM_SIGN_UP_START: 'clickstream_sign_up_start',
  CLICKSTREAM_SIGN_UP_SUCCESS: 'clickstream_sign_up_success',
  CLICKSTREAM_SUCCESS: 'clickstream_success',
  CLICKSTREAM_NOTIFICATIONS: 'clickstream_notifications',
} as const

export const BUSINESS_UNIT = 'wt' as const
export const APP_ID = 'ucf' as const

export const PROD_RIO_ENDPOINT =
  'https://analytics.chegg.com/rio-service-web/rest/rio-events/batch'
export const NON_PROD_RIO_ENDPOINT =
  'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch'
